@let displayedFundValuations = displayedFundValuations$ | async;
@if ((displayedFundValuations)?.length !== 0) {
  <mat-dialog-content>
    <ng-container [formGroup]="fundValuationCopyForm">
      <div class="copy-valuation-fields">
        @if (isValuationPath()) {
          <div>
            <mat-form-field appearance="fill" class="target-report-select">
              <mat-label>Target Fund Report</mat-label>
              <mat-select formControlName="targetFundReportId" id="targetFundReportId">
                @for (report of (sortedFundReports$ | async) ?? []; track report.id) {
                  <mat-option [value]="report.id">{{report.reportDate | traceableFormat}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        <div>
          <mat-form-field appearance="fill" class="input-date-narrow" subscriptSizing="dynamic">
            <mat-label>Closing Date</mat-label>
            <input matInput
              formControlName="closingDate"
              id="closingDate"
              [errorStateMatcher]="closingDateErrorMatcher"
              [matDatepicker]="closingDatePicker">
            <mat-hint>dd/MM/yyyy</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="closingDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #closingDatePicker></mat-datepicker>
            @if (fundValuationCopyForm.controls.closingDate.hasError('required')) {
              <mat-error>
                Closing date is required
              </mat-error>
            }
            @if (fundValuationCopyForm.controls.closingDate.hasError('dateBefore')) {
              <mat-error>
                Must be on or after {{ fundValuationCopyForm.controls.closingDate.getError('dateBefore').requiredDate | date }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="description-form-field">
            <mat-label>Description</mat-label>
            <input matInput
              formControlName="description"
              id="description">
          </mat-form-field>
        </div>
      </div>
      <div class="table-scroll-wrapper">
        <table mat-table [dataSource]="displayedFundValuations ?? []" matSort
               matSortActive="closingDate" [matSortDirection]="sortDirection" [matSortDisableClear]="true"
               (matSortChange)="onSortChange($event)">
          <ng-container matColumnDef="selected">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox
                color="primary"
                [checked]="isRowSelected(element.id)"
                (change)="onSelectFundValuation(element.id, $event.checked)"
                [disabled]="!!copyConfig?.fundValuationCopyConfig?.fundValuationId">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="closingDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="closingDate">Closing Date</th>
            <td mat-cell *matCellDef="let element">{{element.closingDate | traceableFormat}}</td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">{{element.description | traceableFormat}}</td>
          </ng-container>
          <ng-container matColumnDef="copyUndrawnValuation">
            <th mat-header-cell *matHeaderCellDef>
              <span class="header-with-hint">
                Copy Undrawn Valuation
                @if (showUndrawnAutoCalcHint$ | async) {
                  <mat-icon
                    class="copy-restriction-tooltip"
                    matTooltip="If unchecked, the unfunded-parameter defaults are applied automatically to recalculate the undrawn valuation."
                    matTooltipPosition="above">
                    info
                  </mat-icon>
                }
              </span>
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-checkbox color="primary" [formControl]="getCopyUndrawnValuationControl(i)"></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="copyBidPriceAdjustment">
            <th mat-header-cell *matHeaderCellDef>Copy Bid Price Adjustment</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-checkbox color="primary" [formControl]="getCopyBidPriceAdjustmentControl(i)"></mat-checkbox>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="fundValuationsColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: fundValuationsColumns" [class.selected-row]="isRowSelected(row.id)"></tr>
        </table>
      </div>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions-vertical" align="end">
    @if (!selectedFundValuationId) {
      <button
        mat-stroked-button
        color="primary"
        (click)="navigateToSummaryPage()">
        Proceed without Fund Valuation
      </button>
    }
    <div>
      @if (!!copyConfig?.fundReportCopyConfig?.fundReportId) {
        <button
          mat-stroked-button
          (click)="navigateToFundReportCopyDialog()">
          Back
        </button>
      }
      <button
        mat-stroked-button
        color="primary"
        [disabled]="!fundValuationCopyForm.valid"
        (click)="navigateToAssetValuationCopyDialog()">
        Next
      </button>
    </div>
  </mat-dialog-actions>
} @else {
  <mat-dialog-content>
    No Fund Valuations exist!
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @if (!!copyConfig?.fundReportCopyConfig?.fundReportId) {
      <button
        mat-stroked-button
        (click)="navigateToFundReportCopyDialog()">
        Back
      </button>
    }
    <button
      mat-stroked-button
      color="primary"
      (click)="navigateToSummaryPage()">
      Next
    </button>
  </mat-dialog-actions>
}
